
import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class CheckoutProgress extends Vue {
  current_route_name = Vue.router.currentRoute.name;
  showMobileProgressPopUp = false;

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal: any) {
    this.current_route_name = Vue.router.currentRoute.name;
  }

  get step1Active() {
    return (
      this.current_route_name == "wizard.one" ||
      this.current_route_name == "wizard.two" ||
      this.current_route_name == "wizard.three" ||
      this.current_route_name == "wizard.four"
    );
  }
  get step1Current() {
    return this.current_route_name == "wizard.one";
  }

  get step2Active() {
    return (
      this.current_route_name == "wizard.two" ||
      this.current_route_name == "wizard.three" ||
      this.current_route_name == "wizard.four"
    );
  }
  get step2Current() {
    return this.current_route_name == "wizard.two";
  }

  get step3Active() {
    return (
      this.current_route_name == "wizard.three" ||
      this.current_route_name == "wizard.four"
    );
  }
  get step3Current() {
    return this.current_route_name == "wizard.three";
  }

  get step4Active() {
    return this.current_route_name == "wizard.four";
  }
  get step4Current() {
    return this.current_route_name == "wizard.four";
  }

  get step1Css() {
    return (
      (this.step1Active ? "active" : "") +
      " " +
      (this.step1Current ? "current" : "")
    );
  }

  get step2Css() {
    return (
      (this.step2Active ? "active" : "") +
      " " +
      (this.step2Current ? "current" : "")
    );
  }

  get step3Css() {
    return (
      (this.step3Active ? "active" : "") +
      " " +
      (this.step3Current ? "current" : "")
    );
  }

  get step4Css() {
    return (
      (this.step4Active ? "active" : "") +
      " " +
      (this.step4Current ? "current" : "")
    );
  }

  get cssClass() {
    let cssClass = "checkoutprogress";
    if (this.step4Active) {
      cssClass += " step4";
    } else if (this.step3Active) {
      cssClass += " step3";
    } else if (this.step2Active) {
      cssClass += " step2";
    } else if (this.step1Active) {
      cssClass += " step1";
    }
    return cssClass;
  }

  get cssMobileClass() {
    let cssClass = "mobile-progress";
    if (this.step4Active) {
      cssClass += " step4";
    } else if (this.step3Active) {
      cssClass += " step3";
    } else if (this.step2Active) {
      cssClass += " step2";
    } else if (this.step1Active) {
      cssClass += " step1";
    }
    return cssClass;
  }

  get getStepNumber() {
    if (this.step4Active) {
      return 4;
    } else if (this.step3Active) {
      return 3;
    } else if (this.step2Active) {
      return 2;
    } else if (this.step1Active) {
      return 1;
    } else {
      return 4;
    }
  }

  get getStepName() {
    if (this.step4Active) {
      return "Payment";
    } else if (this.step3Active) {
      return "Details";
    } else if (this.step2Active) {
      return "Account";
    } else if (this.step1Active) {
      return "Coverages";
    } else {
      return "";
    }
  }

  showMobileProgressBar() {
    this.addNoScroll();
    this.showMobileProgressPopUp = true;
  }

  hideMobileProgressBar() {
    this.removeNoScroll();
    this.showMobileProgressPopUp = false;
  }

  created() {
    // Register browser back/forward event
    window.addEventListener("popstate", this.onPopState);
  }

  beforeDestroy() {
    // remove the event listener
    window.removeEventListener("popstate", this.onPopState);
  }

  /**
   * Back or forward button has been clicked on browser.
   */
  onPopState() {
    // Remove no scroll, so when we return to the main window it can scroll
    this.removeNoScroll();
    this.hideMobileProgressBar();
  }

  /**
   * Add no scroll to the main body, so we don't get main window
   * scrolling while we're shown as modal.
   */
  addNoScroll() {
    // Fixes the scrolling of the checkout progress on mobile
    let el = document.getElementsByTagName("body");
    if (el && el[0]) {
      el[0].classList.add("noscroll");
    }
  }

  /**
   * Remove the noscroll class, so the main window can scroll.
   */
  removeNoScroll() {
    // Fixes the scrolling of the checkout progress on mobile
    let el = document.getElementsByTagName("body");
    if (el && el[0]) {
      el[0].classList.remove("noscroll");
    }
  }
}
